import React from 'react';
import Loader from '@iso/components/utility/loader';
import IntlMessages from '@iso/components/utility/intlMessages';
import VerifyPageWrapper from './VerifyPage.styles';
import { withRouter, useHistory } from 'react-router-dom';
import queryString from 'query-string';
import { userService } from '@iso/services';
import { useDispatch, useSelector } from 'react-redux';
import authAction from '@iso/redux/auth/actions';
import appAction from '@iso/redux/app/actions';
import { isDesktop, isTablet } from "react-device-detect";
import userActions from '@iso/redux/user/actions';

const { login } = authAction;
const { clearMenu } = appAction;
const { store } = userActions;

const VerifyPage = (props) => {
  const [message, setMessage] = React.useState('');
  const token = queryString.parse(props.location.search).token || '';
  const property_id = queryString.parse(props.location.search).property_id || '';
  const email = queryString.parse(props.location.search).email || '';
  const sharingToken = queryString.parse(window.location.search).sharing_token || '';
  const deeplink = queryString.parse(props.location.search).deeplink || '';
  const formToken = queryString.parse(window.location.search).form_token || '';
  const dispatch = useDispatch();
  const currentUser = useSelector((state) => state.user.user);
  const isAuthenticated = useSelector((state) => state.Auth.idToken);
  let history = useHistory();

  React.useEffect(() => {
    // Check if this is an invitation link and user is already logged in
    if (token && property_id && isAuthenticated && currentUser) {
      // Only redirect to invitation conflict if the logged-in user is different from the invited user
      const invitedEmail = email ? decodeURIComponent(email).toLowerCase() : '';
      const currentUserEmail = currentUser.email?.toLowerCase();
      
      if (invitedEmail && currentUserEmail !== invitedEmail) {
        // Redirect to invitation conflict page only when different users
        const conflictParams = queryString.stringify({
          token,
          property_id,
          email: email || '',
          deeplink,
          formToken,
          sharingToken
        });
        history.push(`/invitation-conflict?${conflictParams}`);
        return;
      }
      // If same user, continue with normal flow (no redirect to conflict page)
    }

    const data = {
      token,
      property_id,
    }
    setTimeout(() => {
      userService.verifyEmail(data).then(res => {
        if(res.access_token){
          dispatch(login(res.access_token));
          dispatch(clearMenu());
          dispatch(store());
          if(formToken && formToken !== ''){
            history.push('/form-submission?token=' + formToken)
          }else if(sharingToken && sharingToken !== ''){
            history.push('/share-map?token=' + sharingToken)
          }else{
            if(!isDesktop && !isTablet && deeplink){
              window.location.href = deeplink
            }else{
              history.push({
                pathname: '/manage-properties',
                state: { visible: true }
              });
            }
          }
        } else {
          if(res.code === '0000'){
            if(!isDesktop && !isTablet && deeplink){
              window.location.href = deeplink
            }else{
              history.push({
                pathname: '/manage-properties',
                state: { visible: true }
              });
            }
          } else {
            // For non-logged-in users with invalid tokens, redirect to signup with error
            if (token && property_id) {
              const signupParams = queryString.stringify({
                token,
                email: email || '',
                error: res.message
              });
              history.push(`/signup?${signupParams}`);
            } else {
              setMessage(res.message);
            }
          }
        }
      })
    }, 2000)
  });

  return (
    <VerifyPageWrapper>
      {
        message ?
        <h1>{message}</h1>
        :
        <>
          <Loader />
          <h1>
            {
              property_id ?
              <IntlMessages id="verifypage.inviteEmail.message" /> :
              <IntlMessages id="verifypage.email.message" />
            }
          </h1>
        </>
      }
      
    </VerifyPageWrapper>
  );
}

export default withRouter(VerifyPage);
